/* src/app/workshop-defects/pages/workshop-defects-edit/workshop-defects-edit.component.scss */
/*# sourceMappingURL=workshop-defects-edit.component.css.map */
